module.exports = __webpack_public_path__ + "img/0039.55520001.jpg";